var $8bccd718fb497022$exports = {};
$8bccd718fb497022$exports = {
    "endTime": `Eindtijd`,
    "startTime": `Starttijd`,
    "time": `Tijd`
};


export {$8bccd718fb497022$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
